import { useOnlineStatus } from './../../../hooks/useOnline';

export function OnlineIndicator({ size = 'sm' }) {
	const sizes: Record<string, string> = {
		sm: 'w-2.5 h-2.5',
		md: 'w-4 h-4',
		lg: 'w-5 h-5',
	};

	const isOnline = useOnlineStatus();

	return (
		<span className="relative inline-flex">
			{isOnline && (
				<span className={`absolute inline-flex rounded-full bg-[#25855A] opacity-60 animate-ping ${sizes[size]}`} />
			)}
			<span
				className={`relative inline-flex rounded-full ${sizes[size]} ${isOnline ? 'bg-[#25855A]' : 'bg-[#A0AEC0]'}`}
			/>
		</span>
	);
}
